module.exports = __webpack_public_path__ + "static/media/profile-sms-correct.da75585f.png";